import { useAppSocket } from '@hooks/appSocket';
import { useAuthStore } from '@stores/authStore';
import { share, ShareOptions } from '@utils/common';
import React from 'react';

interface ShareButtonProps {
  id?: string;
  iconColor?: string;
  iconStyle?: any;
  shareOptions?: ShareOptions;
  style?: any;
}

export const ShareIcon: React.FC<{ color?: string; style?: any }> = (props) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" style={props.style}>
      <g id="Icon/Outline/share-white">
        <path
          id="Vector"
          d="M22.9168 21.0007C22.9168 22.0592 22.0587 22.9173 21.0002 22.9173V24.9173C23.1633 24.9173 24.9168 23.1638 24.9168 21.0007H22.9168ZM21.0002 22.9173C19.9416 22.9173 19.0835 22.0592 19.0835 21.0007H17.0835C17.0835 23.1638 18.837 24.9173 21.0002 24.9173V22.9173ZM21.0002 19.084C22.0587 19.084 22.9168 19.9421 22.9168 21.0007H24.9168C24.9168 18.8375 23.1633 17.084 21.0002 17.084V19.084ZM22.9168 7.00065C22.9168 8.0592 22.0587 8.91732 21.0002 8.91732V10.9173C23.1633 10.9173 24.9168 9.16377 24.9168 7.00065H22.9168ZM19.0835 7.00065C19.0835 5.94211 19.9416 5.08398 21.0002 5.08398V3.08398C18.837 3.08398 17.0835 4.83754 17.0835 7.00065H19.0835ZM21.0002 5.08398C22.0587 5.08398 22.9168 5.94211 22.9168 7.00065H24.9168C24.9168 4.83754 23.1633 3.08398 21.0002 3.08398V5.08398ZM7.00016 15.9173C5.94162 15.9173 5.0835 15.0592 5.0835 14.0007H3.0835C3.0835 16.1638 4.83705 17.9173 7.00016 17.9173V15.9173ZM5.0835 14.0007C5.0835 12.9421 5.94162 12.084 7.00016 12.084V10.084C4.83705 10.084 3.0835 11.8375 3.0835 14.0007H5.0835ZM8.91683 14.0007C8.91683 14.3106 8.84399 14.6007 8.7154 14.8574L10.5036 15.7532C10.7683 15.2248 10.9168 14.6286 10.9168 14.0007H8.91683ZM8.7154 14.8574C8.3995 15.488 7.74907 15.9173 7.00016 15.9173V17.9173C8.53498 17.9173 9.86175 17.0343 10.5036 15.7532L8.7154 14.8574ZM7.00016 12.084C7.74907 12.084 8.3995 12.5133 8.7154 13.1439L10.5036 12.2481C9.86175 10.967 8.53498 10.084 7.00016 10.084V12.084ZM8.7154 13.1439C8.84399 13.4006 8.91683 13.6907 8.91683 14.0007H10.9168C10.9168 13.3727 10.7683 12.7765 10.5036 12.2481L8.7154 13.1439ZM9.16227 16.1997L17.9436 20.5904L18.8381 18.8016L10.0567 14.4109L9.16227 16.1997ZM19.0835 21.0007C19.0835 20.6907 19.1563 20.4006 19.2849 20.1439L17.4968 19.2481C17.232 19.7765 17.0835 20.3727 17.0835 21.0007H19.0835ZM19.2849 20.1439C19.6008 19.5133 20.2513 19.084 21.0002 19.084V17.084C19.4654 17.084 18.1386 17.967 17.4968 19.2481L19.2849 20.1439ZM17.9436 7.41088L9.16227 11.8016L10.0567 13.5904L18.8381 9.19974L17.9436 7.41088ZM21.0002 8.91732C20.2513 8.91732 19.6008 8.48796 19.2849 7.8574L17.4968 8.75322C18.1386 10.0343 19.4654 10.9173 21.0002 10.9173V8.91732ZM19.2849 7.8574C19.1563 7.60072 19.0835 7.31063 19.0835 7.00065H17.0835C17.0835 7.62861 17.232 8.22476 17.4968 8.75322L19.2849 7.8574Z"
          fill={props.color || 'white'}
        />
      </g>
    </svg>
  );
};

export const ShareButton: React.FC<ShareButtonProps> = (props) => {
  const authStore = useAuthStore();
  const appSocket = useAppSocket();
  const { iconColor, iconStyle, shareOptions } = props;
  return (
    <button
      className="share-button"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        borderWidth: 0,
        cursor: 'pointer',
        ...props.style,
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (shareOptions) {
          share(shareOptions);
          const shareData: any = {
            from: document.location.pathname,
            actionType: 'share',
            id: props.id,
          };

          if (shareOptions?.type === 'collection') {
            shareData['collectionId'] = shareOptions?.id;
          } else {
            shareData['productId'] = shareOptions?.id;
          }
          shareData['shareType'] = shareOptions?.type || 'product';
          appSocket.sendEvent({
            type: 'click',
            data: {
              userId: authStore.user?.id,
              path: document.location.pathname,
              actionData: shareData,
            },
          });
        }
      }}>
      <ShareIcon color={iconColor || '#242424'} style={iconStyle} />
    </button>
  );
};

export default ShareButton;
